<template>
  <div>
    <h4>Natureza e Áreas</h4>
    <div class="border rounded-lg p-3 mb-4">
      <b-form-group label="Áreas da Oportunidade:">
        <SelectArea v-model="oportunidade.areas" :multiple="true" />
        <b-form-invalid-feedback :state="validateState('areas')">
          <span v-if="!v$.oportunidade.areas.required">
            Áreas da Oportunidade é um campo obrigatório.
          </span>
        </b-form-invalid-feedback>
      </b-form-group>

      <base-input
        label="Natureza Jurídica:"
        :show-warning="revisao('programa_atende_a')"
      >
        <SelectTiposInstituicoes
          v-model="oportunidade.instituicoes_tipos"
          class="list-tipos"
        />
        <b-form-invalid-feedback :state="validateState('instituicoes_tipos')">
          <span v-if="!v$.oportunidade.instituicoes_tipos.required">
            Natureza Jurídica é um campo obrigatório.
          </span>
        </b-form-invalid-feedback>
      </base-input>
    </div>

    <h4>Abrangência</h4>
    <div class="border rounded-lg p-3 mb-4">
      <select-country v-model="oportunidade.paises" />
      <hr class="my-5" />
      <h4 class="text-exitos">
        <font-awesome-icon icon="location-dot" />
        Território brasileiro
      </h4>
      <b-tabs v-model="activeTab" class="custom-tabs" content-class="mt-1">
        <b-tab title="Seleção manual">
          <select-multi-municipio v-model="destinosTerritoriais" class="mt-3" />
        </b-tab>
        <b-tab title="Importar arquivo">
          <import-municipios @before="activeTab = 0" />
        </b-tab>
      </b-tabs>
    </div>

    <h4>Objetivos de Desenvolvimento Sustentável</h4>
    <div class="border rounded-lg p-3 mb-3">
      <b-form-group label="ODS:">
        <Ods v-model="oportunidade.ods" />
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from "vue";
import useVuelidate from "@vuelidate/core";
import SelectArea from "@/modules/areas/Components/SelectArea.vue";
import SelectCountry from "@/modules/oportunidades/Components/SelectCountry.vue";
import SelectMultiMunicipio from "@/modules/oportunidades/Components/SelectMultiMunicipio.vue";
import Ods from "@/components/Form/Ods.vue";
import SelectTiposInstituicoes from "@/modules/tipos_instituicoes/Components/SelectTiposInstituicoes.vue";
import BaseInput from "./BaseInput.vue";
import ImportMunicipios from "@/modules/oportunidades/Components/ImportMunicipios.vue";
import { useNamespacedState } from "vuex-composition-helpers";
import { safeArray } from "@/helpers/functions/ArrayHelpers.js";

export default defineComponent({
  components: {
    SelectArea,
    SelectCountry,
    SelectMultiMunicipio,
    ImportMunicipios,
    Ods,
    SelectTiposInstituicoes,
    BaseInput,
  },
  setup() {
    const activeTab = ref(0);

    const { oportunidade } = useNamespacedState("oportunidades", [
      "oportunidade",
    ]);

    const rules = {
      oportunidade: {
        instituicoes_tipos: {},
        areas: {},
      },
    };

    const v$ = useVuelidate(rules, { oportunidade });

    const destinosTerritoriais = computed({
      get() {
        return {
          estados: oportunidade.value?.estados,
          municipios: oportunidade.value?.municipios,
        };
      },
      set(value) {
        if (!oportunidade.value) return;

        oportunidade.value.estados = value.estados;
        oportunidade.value.municipios = value.municipios;
      },
    });

    function validateState(name) {
      const { $dirty, $error } = v$.value?.oportunidade?.[name];
      return $dirty ? !$error : null;
    }

    function isValid() {
      v$.value?.oportunidade?.$touch();
      return !v$.value?.oportunidade?.$anyError;
    }

    function revisao(campo) {
      if (!!oportunidade.value?.campos_revisao) {
        return safeArray(oportunidade.value.campos_revisao).some(
          (item) => item.campo === campo
        );
      }

      return false;
    }

    return {
      v$,
      oportunidade,
      activeTab,
      destinosTerritoriais,
      validateState,
      isValid,
      revisao,
    };
  },
});
</script>

<style scoped lang="scss">
.list-tipos {
  max-width: 100%;
  width: 100%;
  display: inline-block;
  column-count: 2;
  column-gap: 32px;
  row-gap: 32px;
}

::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  background-color: var(--exitos) !important;
  border-color: var(--exitos) !important;
}

::v-deep
  .custom-control-input:not(:disabled):active
  ~ .custom-control-label::before {
  background-color: var(--exitos) !important;
  border-color: var(--exitos) !important;
}

::v-deep .custom-tabs {
  .nav-tabs {
    border-bottom: 0;
  }

  .nav-item:first-of-type .nav-link {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-right: 0;
  }

  .nav-item + .nav-item > .nav-link {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }

  .nav-link {
    padding: 10px !important;
    border-color: #dee2e6;
    border-radius: 0.375rem;
    font-weight: 600;

    &.active {
      background-color: var(--exitos);
      color: var(--white);
    }

    &:hover:not(.active) {
      color: var(--exitos);
    }
  }
}
</style>
